import { useNavigate, useParams } from "react-router-dom";
import { LoadingCount } from "@volca/ui/components/ui/loading-count";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@volca/ui/components/ui/tabs";
import { SIDEBAR_MODES, SIDEBAR_SECTIONS } from "@/business-settings/constants";
import { useBusinessSettingsSidebar } from "@/business-settings/context/business-settings-sidebar-context";
import { useGetInternalTransactions } from "@/internal-transactions/query";
import { useGetPayouts } from "@/payouts/query";
import { InternalTransactions } from "./internal-transactions";
import { ReferralPayments } from "./referral-payments";

const PaymentsTable = () => {
  const { updateSidebar } = useBusinessSettingsSidebar();
  const navigate = useNavigate();
  const { businessId, tab } = useParams();
  const activeTab = tab ?? SIDEBAR_SECTIONS.referralPayments;

  const { data: referralPayouts, isLoading: isReferralPayoutsLoading } =
    useGetPayouts(businessId);
  const {
    data: internalTransactions,
    isLoading: isInternalTransactionsLoading,
  } = useGetInternalTransactions(businessId);

  const referralPaymentsCount = referralPayouts?.length ?? 0;
  const internalTransactionsCount = internalTransactions?.length ?? 0;

  const handleTabChange = (tab: string) => {
    updateSidebar({
      selectedItemId: undefined,
      mode: SIDEBAR_MODES.view,
      section:
        tab === SIDEBAR_SECTIONS.referralPayments
          ? SIDEBAR_SECTIONS.referralPayments
          : SIDEBAR_SECTIONS.internalTransactions,
      isOpen: false,
    });
    navigate(`/business-settings/${businessId}/payments/${tab}`);
  };

  return (
    <Tabs
      value={activeTab}
      onValueChange={handleTabChange}
      className="flex w-full flex-1 flex-col gap-0 overflow-hidden"
    >
      <TabsList className="max-w-full max-sm:overflow-x-auto max-sm:overflow-y-hidden">
        <TabsTrigger value={SIDEBAR_SECTIONS.referralPayments}>
          Referral payments
          <LoadingCount
            count={referralPaymentsCount}
            isCountLoading={isReferralPayoutsLoading}
            size="small"
          />
        </TabsTrigger>
        <TabsTrigger value={SIDEBAR_SECTIONS.internalTransactions}>
          Internal transactions
          <LoadingCount
            count={internalTransactionsCount}
            isCountLoading={isInternalTransactionsLoading}
            size="small"
          />
        </TabsTrigger>
      </TabsList>
      <TabsContent
        value={SIDEBAR_SECTIONS.referralPayments}
        className="min-h-0 flex-1 flex-col overflow-hidden pt-2 not-data-hidden:flex"
      >
        <ReferralPayments businessId={businessId} />
      </TabsContent>
      <TabsContent
        value={SIDEBAR_SECTIONS.internalTransactions}
        className="min-h-0 flex-1 flex-col overflow-hidden pt-2 not-data-hidden:flex"
      >
        <InternalTransactions />
      </TabsContent>
    </Tabs>
  );
};

export default PaymentsTable;
